import { Route, Routes } from 'react-router-dom';
import * as PATHS from './CONSTANTS';
import Login from '../pages/auth/login/index'
import DashBoard from '../pages/dashboard';
import Resources from '../pages/resources';
import CreatePositions from '../pages/createPositions';
import Positions from '../pages/positions';
import ResourcePositions from '../pages/applyPositions';
import AppliedCandidates from '../pages/positionDetails';
import Company from '../pages/company';
import PageInfo from '../pages/pageInfo';
import ResourceApplyPosition from '../pages/resourceApplyPositions';
import CreateResource from '../pages/createResource/index';
import CreateCompany from '../pages/createCompany';
import Blacklisted from '../pages/blacklisted';
import Rejected from '../pages/rejected';
import InContract from '../pages/inContract';
import MyWorkplaceUsers from '../pages/myWorkplaceUsers';
import Settings from '../pages/settings/index'
import CompanySettings from '../pages/companySettings';
import Survey from '../pages/Questionire'
import CompanyTimesheet from '../pages/companyTimesheet';
import CompanyTimesheetSettings from '../pages/companyTimesheetSettings';
import CandidateTimesheet from '../pages/candidateTimeSheet';
import CandidateTimesheetSettings from '../pages/candidateTimesheetSettings';
import PublicDatabase from "../pages/publicDatabase";
import UploadHistory from "../pages/uploadHistory";
import JsonResponse from "../pages/publicDatabase/jsonResponse";
import CandidateTimeSheetDownload from "../pages/candidateTimeSheet/candidateTimeSheetDownload";
import Reports from '../pages/reports';
import Signup from '../pages/auth/signup';
import CRcreateResource from '../pages/CRcreateResource';
import CRpositions from '../pages/CRpositions';
import CRresources from '../pages/CRresources';
import CRPositionDetails from '../pages/CRPositionDetails';
import CRApplyPositions from '../pages/CRapplyPositions';
import CRResourcesTab from '../pages/CRresourceTab'
import FallbackPage from '../pages/fallbackPage';
import ReferedCandidates from '../pages/referedCandidates';



const RouterConfig = () => {
    return (
        <Routes>

            <Route path={PATHS.LOGIN} element={<Login />} />
            <Route path={PATHS.LOGIN1} element={<Login />} />
            <Route path={PATHS.DASHBOARD} element={<DashBoard />} />
            <Route path={PATHS.RESOURCES} element={<Resources />} />
            <Route path={PATHS.CREATEPOSITIONS} element={<CreatePositions />} />
            <Route path={PATHS.POSITIONS} element={<Positions />} />
            <Route path={PATHS.RESOURCEPOSITIONS} element={<ResourcePositions />} />
            <Route path={PATHS.APPLIEDCANDIDATES} element={<AppliedCandidates />} />
            <Route path={PATHS.COMPANY} element={<Company />} />
            <Route path={PATHS.INFORMATIONPAGE} element={<PageInfo />} />
            <Route path={PATHS.RESOURCEAPPLYPOSITIONS} element={<ResourceApplyPosition />} />
            <Route path={PATHS.CREATERESOURCES} element={<CreateResource />} />
            <Route path={PATHS.CREATECOMPANY} element={<CreateCompany />} />
            <Route path={PATHS.BLACKLISTED} element={<Blacklisted />} />
            <Route path={PATHS.REJECTED} element={<Rejected />} />
            <Route path={PATHS.INCONTRACT} element={<InContract />} />
            <Route path={PATHS.MYWORKPLACEUSERS} element={<MyWorkplaceUsers />} />
            <Route path={PATHS.SETTINGS} element={<Settings />} />
            <Route path={PATHS.COMPANYSETTINGS} element={<CompanySettings />} />
            {/* <Route path={PATHS.RECRUITERSIGNUP} element={< CustomerSignup/>} />
            <Route path={PATHS.RECRUITERSIGNUP} element={< DashBoard/>} /> */}
            <Route path={PATHS.SURVEY} element={<Survey />} />
            <Route path={PATHS.COMPANYTIMESHEET} element={<CompanyTimesheet />} />
            <Route path={PATHS.COMPANYTIMESHEETSETTINGS} element={<CompanyTimesheetSettings />} />
            <Route path={PATHS.CANDIDATETIMESHEET} element={<CandidateTimesheet />} />
            <Route path={PATHS.CANDIDATETIMESHEETSETTINGS} element={<CandidateTimesheetSettings />} />
            <Route path={PATHS.PUBLICDATABASE} element={<PublicDatabase />} />
            <Route path={PATHS.UPLOADHISTORY} element={<UploadHistory />} />
            <Route path={PATHS.JSONRESPONSE} element={<JsonResponse />} />
            <Route path={PATHS.CANDIDATETIMESHEETDOWNLOAD} element={<CandidateTimeSheetDownload />} />
            <Route path={PATHS.REPORTS} element={<Reports/>} />
            <Route path={PATHS.SIGNUP} element={<Signup/>}/>
            <Route path={PATHS.REPORTS} element={<Reports />} />
            <Route path={PATHS.CRCREATERESOURCES} element={<CRcreateResource />} />
            <Route path={PATHS.CRPOSITIONS} element={<CRpositions />} />
            <Route path={PATHS.CRRESOURCES} element={<CRresources/>} />
            <Route path={PATHS.CRPOSITIONDETAILS} element={<CRPositionDetails/>} />
            <Route path={PATHS.CRAPPLYPOSITIONS} element={<CRApplyPositions/>}/>
            <Route path={PATHS.CRRESOURCESTAB} element={<CRResourcesTab />} />
            <Route path={PATHS.REFERANDEARN} element={<ReferedCandidates/>} />
            <Route path={PATHS.FALLBACKPAGE} element={<FallbackPage/>} />
        </Routes>
    )
}

export default RouterConfig;